import { BaseUrl } from "../ApiService/BaseUrl";

/** Files uploaded from the admin panel are served by the API at /uploads. */
export function uploadUrl(fileName: string | undefined | null): string | null {
  if (!fileName) return null;
  if (/^https?:\/\//i.test(fileName)) return fileName;
  return `${BaseUrl}/uploads/${encodeURIComponent(fileName)}`;
}

export function imageUrl(fileName: string | undefined | null, fallback: string): string {
  return uploadUrl(fileName) ?? fallback;
}

/** Initials avatar used when no profile photo has been uploaded. */
export function avatarFallback(name = "Ali", size = 200, background = "ffffff", color = "0f172a"): string {
  return `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&size=${size}&background=${background}&color=${color}&font-size=0.4`;
}

/** Same avatar in the admin panel's colours. */
export function adminAvatarFallback(name = "Admin", size = 96): string {
  return avatarFallback(name, size, "0ea5e9", "ffffff");
}

export const PROJECT_PLACEHOLDER =
  "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
